// frontend/app/locales/en.ts
export const en = {
  sidebar: {
    main: "Main",
    planning: "Planning",
    closings: "Closings",
    system: "System",
    dashboard: "Dashboard",
    transactions: "Transactions",
    investments: "Investments",
    calendar: "Calendar",
    recurring: "Recurring",
    envelopes: "Envelopes",
    debts: "Debts & Credits",
    goals: "Goals",
    documents: "Document Inbox",
    balance: "Balances",
    data: "Anagraphics",
    settings: "Settings",
    logout: "Log Out",
    login: "Log In",
    language: "Language",
    more: "More",
    home: "Home",
    expenses: "Expenses",
    envelopes_short: "Envelopes",
    wishlist: "Wishlist",
    admin_section: "Administration",
    admin_users: "User Management",
    admin_market: "Market Data",
    support: "Support",
    admin_tickets: "Manage Tickets",
    admin_analytics: "Usage Analytics",
    admin_settings: "System Settings",
  },
  settings: {
    title: "Settings",
    subtitle: "Manage your preferences, profile, and security credentials.",
    profile: "Personal Profile",
    preferences: "System Preferences",
    security: "Security",
    database_status: "Database Status",
    export_import: "Export & Import",
    email_briefings: "Daily Briefings & Reports",
    save: "Save Settings",
    change_password: "Change Password",
    current_password: "Current Password",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    bio_authentication: "Biometric Authentication (Passkeys)",
    register_passkey: "Register Passkey",
    db_status_msg: "PostgreSQL database is active and synced successfully.",
    export_btn: "Export JSON Data",
    import_btn: "Import JSON Data",
    receive_briefings: "Receive morning briefing",
    receive_weekly: "Receive weekly report",
    receive_monthly: "Receive monthly report",
    base_currency: "Base Currency",
    timezone: "Timezone",
    theme_label: "Display Theme",
    theme_dark: "Dark Mode",
    theme_light: "Light Mode",
    personal_info: {
      username: "Username",
      email: "Email",
      first_name: "First Name",
      last_name: "Last Name",
      date_of_birth: "Date of Birth",
      phone_number: "Phone Number",
      address: "Address",
      city: "City",
      state: "State/Province",
      postal_code: "Postal Code",
      country: "Country",
      gender: "Gender",
      select_gender: "Select...",
      male: "Male",
      female: "Female",
      other_gender: "Other",
      address_details: "Details (Building, Apartment)",
      address_details_placeholder: "E.g., Apt 4B",
      address_placeholder: "E.g., 123 Main St",
      city_placeholder: "New York",
      state_placeholder: "NY",
      postal_code_placeholder: "10001",
      job_section: "Employment & Tax",
      tax_id: "Tax ID",
      tax_id_placeholder: "SSN or similar...",
      employment_status: "Employment Status",
      employment_status_placeholder: "Employed, Freelancer...",
      job_title: "Job Title",
      job_title_placeholder: "Software Engineer..."
    },
    telegram: {
      title: "Telegram Bot Integration",
      desc: "To use the bot, send it the {cmd} command to find out your ID, then enter it below.",
      placeholder: "E.g., 123456789"
    },
    password_section: {
      title: "Access Password",
      desc: "Regularly update your password to keep your account secure.",
      btn: "Change Password",
      modal_title: "Change Password",
      cancel: "Cancel",
      confirm: "Confirm",
      saving: "Saving..."
    },
    biometric: {
      title: "Biometric Login",
      desc: "Log in quickly using Face ID, Touch ID, or Windows Hello."
    },
    two_fa: {
      title: "Two-Factor Authentication (2FA)",
      status_active: "ACTIVE",
      desc: "Protect your account with a one-time code generated by an authenticator app.",
      disable_btn: "Disable 2FA",
      enable_btn: "Configure 2FA",
      modal_title: "Configure 2FA",
      modal_desc: "Scan this code with your authenticator app (Google Authenticator, Authy, Raivo, etc.)",
      manual_entry: "Or manually enter the secret code:",
      verify_label: "Enter code to verify",
      verify_btn: "Activate Now",
      verifying: "Verifying...",
      prompt_disable: "Enter the 2FA code to confirm deactivation:"
    },
    briefings: {
      morning_label: "Morning Briefing",
      morning_desc: "Summary of yesterday's expenses and upcoming deadlines.",
      weekly_label: "Weekly Wrap-Up",
      weekly_desc: "Analysis of budget performance every week.",
      monthly_label: "Executive Summary",
      monthly_desc: "In-depth monthly net worth statement."
    },
    toasts: {
      qr_err: "Error generating QR Code",
      conn_err: "Connection error",
      two_fa_enabled: "Two-factor authentication activated!",
      invalid_code: "Invalid code",
      two_fa_disabled: "2FA deactivated.",
      disable_failed: "Invalid code. Deactivation failed.",
      profile_saved: "Profile updated!",
      save_err: "Error saving profile",
      pref_saved: "Preference saved!",
      pref_save_err: "Could not save preference.",
      export_success: "Data exported successfully!",
      export_failed: "Error exporting data.",
      passkey_todo: "Passkey function to be restored here",
      password_mismatch: "New passwords do not match!",
      password_changed: "Password changed successfully!",
      password_change_err: "Error changing password",
      loading: "Loading settings..."
    }
  },
  dashboard: {
    title: "Financial Dashboard",
    subtitle: "Net Worth Dashboard Panel",
    overview_tab: "Overview",
    wealth_tab: "Wealth & FIRE",
    behavior_tab: "Behavior",
    history_tab: "History & Records",
    forecast_tab: "Forecasts",
    merchants_tab: "Merchants",
    budget_tab: "Budgets",
    seasonality_tab: "Seasonality",
    gamification_tab: "Financial RPG",
    investments_tab: "Investments",
    insights_tab: "Advanced Insights",
    range_label: "Period:",
    insights: {
      title: "Advanced Insights & Financial Analytics",
      subtitle: "Detailed analysis of your spending behavior and structure.",
      treemap_title: "Treemap Visualization of Income and Expenses",
      treemap_categories_exp: "Spending Categories",
      treemap_categories_inc: "Income Categories",
      treemap_merchants_exp: "Spending Merchants",
      treemap_merchants_inc: "Income Merchants",
      treemap_value: "Value",
      essential_ratio: "Cost Structure: Fixed vs Discretionary Expenses",
      essential_label: "Fixed & Essential Expenses",
      discretionary_label: "Discretionary & Leisure",
      volatility_title: "Monthly Expense Volatility",
      volatility_desc: "Standard deviation of outflows. Lower values mean stability and predictability.",
      savings_trend: "Savings Rate Trend",
      trend_improving: "IMPROVING 📈",
      trend_degradating: "DEGRADATING 📉",
      trend_stable: "STABLE ➡️",
      emergency_fund_title: "Emergency Fund & Cost Coverage",
      fund_secure: "SECURE (Covers > 6 months)",
      fund_adequate: "ADEQUATE (Covers 3-6 months)",
      fund_critical: "CRITICAL (< 3 months)",
      runway_months: "{months} months of autonomy",
      milestones_title: "Net Worth Milestones Projection",
      milestones_desc: "Estimated time to reach financial milestones based on recent monthly savings of ({savings}/month).",
      milestone_target: "Milestone",
      milestone_time: "Est. Time",
      milestone_status: "Status",
      status_completed: "Completed ✅",
      status_planning: "Planned ⏳",
      never_reachable: "Not reachable (negative savings)"
    },
    view_as: "View as:",
    burn_rate: "Daily Burn Rate",
    avg_ticket: "Average Ticket",
    micro_tx: "Coffee Syndrome (<15€)",
    no_spend_days: "No-Spend Days",
    runway: "Runway (Survival)",
    years_to_fire: "Years to F.I.R.E.",
    fire_target: "Independence Target",
    net_worth: "Net Worth",
    liquid: "Liquid",
    invested: "Invested",
    locked_goals: "In Goals",
    velocity: "Wealth Velocity",
    savings_rate: "Savings Rate",
    distribution: "Account Distribution",
    in_bank: "In Bank",

    // Overview
    unconfirmed_alert: "You have {count} transactions awaiting confirmation!",
    unconfirmed_sub: "They could be subscriptions or Telegram entries.",
    go_to_tx: "Go to Transactions",
    net_worth_in_bank: "In Bank (Real):",
    net_worth_in_goals: "In Envelopes:",
    net_worth_credits: "Pending Credits:",
    net_worth_debts: "Pending Debts:",
    current_month_balance_title: "Current Month Balance",
    pacing_title: "Month Spending Pacing",
    pacing_time: "Time ({days}d)",
    pacing_spent: "Spent budget",
    eom_forecast_title: "End of Month Forecast",
    eom_forecast_sub: "Estimate based on Burn Rate ({rate}/d)",
    financial_pressure_title: "Schedule & Financial Pressure",
    pressure_upcoming_7d: "Upcoming (7d)",
    pressure_remaining_month: "Remaining Month",
    pressure_next_month: "Next Month",
    pressure_fixed_costs: "Fixed Costs/Month",
    outflows_plural: "{count} outflows",
    planned_plural: "{count} planned",
    pressure_base_msg: "Base pressure",

    // Wealth
    wealth_breakdown: "Wealth Breakdown",
    in_bank_label: "In bank: {amount}",
    credits_short: "{amount} Credits",
    debts_short: "{amount} Debiti",
    wealth_velocity_label: "Wealth Velocity: {amount} / day",
    savings_rate_label: "Savings Rate (Month)",
    savings_rate_sub: "Target: 20% | Investment Rate: {rate}%",
    fire_projection_title: "F.I.R.E. Projection",
    fire_years: "{years} years",
    fire_years_over_50: "> 50 years",
    fire_target_label: "Independence Target: {amount}",
    runway_label: "Runway (Survival):",
    runway_value: "{years} years",
    progression_12m: "Wealth Progression (12m)",
    account_distribution: "Account Distribution",
    of_which_locked: "(Of which {amount} locked)",

    // Behavior
    dow_title: "Spending by Day of the Week",
    dow_avg: "Average",
    weekend_weekday: "Weekend vs Weekday",
    weekday_label: "Mon-Fri",
    weekend_label: "Sat-Sun",
    month_rhythm: "Month Rhythm",
    first_half_label: "Days 1-15",
    second_half_label: "Days 16-31",
    income_expense_ratio_title: "Income / Expense Ratio (All-Time)",
    ratio_desc: "For every 1€ spent, you earn {ratio}€",
    tx_count_label: "{count} tx",

    // History
    lifetime_flow: "Lifetime Cash Flow",
    lifetime_flow_desc: "Money passed through since day one.",
    generated_label: "Generated",
    burned_label: "Burned",
    monthly_income_history: "Monthly Income History (All-Time)",
    monthly_expense_history: "Monthly Expense History (All-Time)",
    monthly_income_tooltip: "Total Income",
    monthly_expense_tooltip: "Total Expense",
    top_expense_categories: "Top Expense Categories (All-Time)",
    top_income_categories: "Top Income Sources (All-Time)",
    hall_of_fame: "Hall of Fame",
    max_single_expense: "Max Single Expense",
    max_single_income: "Max Single Income",
    worst_day: "Worst Day",
    max_no_spend_streak: "Max No-Spend Streak",
    days_suffix: "{days} d",
    days_suffix_streak: "{days} days 🔥",
    table: {
      year: "Year",
      income: "Income",
      outflows: "Outflows",
      net_savings: "Net Savings",
      pct_sav: "% Sav"
    },

    // Forecast
    time_horizon: "Time Horizon",
    years_label: "{years} Years",
    annual_return: "Annual Investment Return",
    capital_invested_compound: "Invested Capital (Compound Interest)",
    today_label: "Today",
    gain_label: "gain",
    liquidity_growth: "Liquidity (Linear Growth)",
    avg_savings_label: "Average savings: {amount}/month",
    projected_total_label: "Projected Total Wealth",
    vs_today_label: "vs Today",
    trajectory_title: "Wealth Trajectory",
    invisible_tax_title: "Invisible Tax (Inflation 2%)",
    inflation_desc: "Your current {amount} of liquidity, kept idle for {years} years, will lose purchasing power by an equivalent value of:",
    year_n: "Year {n}",

    // Merchants
    merchants_controparte: "Counterparty",
    merchants_tx: "Transactions",
    merchants_total: "Total ({type})",
    merchants_outflow: "Spent",
    merchants_inflow: "Received",
    merchants_none: "No counterparties found.",
    merchants_page: "Page {page} of {total}",
    merchants_prev: "Previous",
    merchants_next: "Next",
    merchants_by_amount: "By Amount",
    merchants_by_freq: "By Frequency",

    // Budget
    budget_delete_title: "Delete Budget",
    budget_delete_msg: "Do you want to remove the budget for {category}?",
    budget_edit_title: "Edit Budget",
    budget_new_title: "Set New Budget",
    budget_cat_label: "Expense Category",
    budget_select_placeholder: "Select...",
    budget_limit_label: "Maximum Limit (€)",
    budget_cancel: "Cancel",
    budget_save: "Save",
    budget_spent_on: "Budget Spending",
    budget_set_limit: "+ Set Limit",
    budget_empty: "You haven't set any monthly budgets yet. Click on \"Set Limit\" to start.",
    budget_remaining: "Remaining: {amount}",

    // Seasonality
    seasonality_title: "Historical Average Spending by Month",

    // Gamification
    rpg_title: "Financial RPG",
    rpg_subtitle: "Your behavioral HUD. Survive the month, beat your records, level up.",
    rpg_boss_title: "Space reserved for Boss Fights (Debts) or Quests",
    rpg_boss_sub: "Coming soon...",

    // Investments
    investments_value: "Total Value",
    investments_capital: "Invested Capital",
    investments_pnl: "Total P&L (Unrealized)",
    investments_positions: "Your Positions",
    investments_tbl: {
      asset: "Asset",
      shares: "Shares",
      pmc: "PMC",
      current_price: "Current Price",
      value: "Value",
      pnl: "P&L"
    },

    // Charts
    sankey: {
      title: "Monthly Cash Flow ({month})",
      footer: "Income ➔ Monthly Budget ➔ Expense / Savings",
      budget_mensile: "Monthly Budget",
      risparmio: "Savings",
      avanzo: "Surplus",
      entrate: "Income",
      spese: "Expenses",
      fondi_buste: "Envelopes",
      erosione: "Erosion"
    },
    milestones: {
      title: "The Pillars of Wealth",
      subtitle: "Your path through financial milestones over time.",
      reached: "Level Achieved",
      real_worth: "Actual Net Worth",
      next_target: "Next Target: €{target}k"
    },
    streak: {
      title: "No-Spend Streak",
      days: "Days",
      broken: "You spent today. The streak is broken.",
      promising: "Promising start. Keep it up.",
      rhythm: "Great job! You're getting into the rhythm.",
      unstoppable: "UNSTOPPABLE! 🔥"
    },
    heatmap: {
      title: "Behavioral Map",
      generating: "Generating map...",
      outflows: "Outflows",
      inflows: "Inflows",
      balance: "Balance",
      mon: "Mon",
      wed: "Wed",
      fri: "Fri",
      jan: "Jan",
      feb: "Feb",
      mar: "Mar",
      apr: "Apr",
      may: "May",
      jun: "Jun",
      jul: "Jul",
      aug: "Aug",
      sep: "Sep",
      oct: "Oct",
      nov: "Nov",
      dec: "Dec"
    }
  },
  transactions: {
    title: "Transactions",
    subtitle: "Manage, filter, and add your movements.",
    filters: "Filters",
    new_tx: "New Transaction",
    search: "Search...",
    start_date: "Start Date",
    end_date: "End Date",
    category: "Category",
    account: "Account",
    payment_method: "Payment Method",
    type: "Type",
    status: "Status",
    all: "ALL",
    income: "Income",
    expense: "Expense",
    transfer: "Transfer",
    unconfirmed: "To Confirm",
    confirm_delete: "Delete Transaction",
    delete_msg: "Are you sure you want to delete this transaction? This action is irreversible.",
    date: "Date",
    description: "Description",
    amount: "Amount",
    notes: "Notes",
    envelope: "Envelope",
    is_envelope_spending: "Spend from Envelope",
    currency: "Currency",
    splits: "Split Expenses",
    contacts: "Contacts",

    // New keys for page & components
    new_btn: "+ New",
    confirm_btn: "Confirm",
    edit_btn: "Edit",
    delete_btn: "Delete",
    no_tx_found: "No transactions found for the selected filters.",
    loading_data: "Loading data...",
    today: "Today",
    yesterday: "Yesterday",
    filter_bar: {
      from_date: "From Date",
      to_date: "To Date",
      search_placeholder: "E.g., Amazon, Dinner, Rent...",
      search_label: "Free Search",
      category_placeholder: "All Categories",
      account_placeholder: "All Accounts",
      quick_filters_label: "Quick Filters:",
      all: "All",
      today: "Today",
      last_7: "Last 7 days",
      this_month: "This Month",
      last_month: "Last Month",
      only_unconfirmed: "Only to Confirm",
      found: "Found:",
      delta: "Delta:"
    },
    modal: {
      nlp_title: "✍️ Quick Fill with AI (Type your transaction here)",
      nlp_placeholder: "e.g., Yesterday I spent 15.50 at Coop with card for dinner",
      nlp_btn: "Parse",
      nlp_processing: "Processing...",
      nlp_success: "Transaction parsed successfully!",
      nlp_no_data: "No transaction found in the text.",
      nlp_error: "Error parsing transaction text.",
      edit_title: "✏️ Edit",
      new_title: "✨ New",
      type_expense: "Expense",
      type_income: "Income",
      type_transfer: "Transfer",
      date_label: "DATE",
      currency_label: "CURRENCY",
      amount_label: "AMOUNT ({currency})",
      description_label: "DESCRIPTION",
      real_bank_charge: "REAL BANK CHARGE ({currency})",
      bank_charge_sub: "How much the bank actually charged on your statement.",
      exchange_rate_label: "EXCHANGE RATE (Including Fees)",
      exchange_rate_sub: "Mathematically calculated by the system.",
      category_label: "CATEGORY",
      new_category_link: "+ New",
      merchant_label: "COUNTERPARTY",
      new_merchant_link: "+ New",
      payment_method_label: "PAYMENT METHOD",
      new_payment_method_link: "+ New",
      money_movement_title: "MONEY MOVEMENT",
      new_account_btn: "+ Create New Account",
      from_account_label: "PAY WITH",
      from_account_transfer_label: "FROM ACCOUNT",
      to_account_label: "DEPOSIT TO",
      to_account_transfer_label: "TO ACCOUNT",
      envelope_title: "✉️ ENVELOPES (Optional)",
      envelope_label: "LINK TO ENVELOPE",
      envelope_placeholder: "No envelope...",
      use_envelope_money: "Use Envelope Funds",
      use_envelope_money_sub: "This expense won't impact your monthly budget because you already set aside the funds in the past.",
      debts_mode_label: "Generate debts/credits linked to this transaction",
      debts_add_item: "+ Add Line",
      debts_title: "Linked Debts / Credits",
      debts_empty: "No linked debts.",
      debts_new_btn: "+ Add New",
      notes_label: "NOTES",
      tags_label: "Tags (press Enter)",
      tags_placeholder: "E.g., vacation, gift...",
      cancel_btn: "Cancel",
      save_btn: "Save",
      saving_btn: "Saving...",
      split_lent: "Lent",
      split_borrowed: "Debt",
      split_to_whom: "To whom?",
      split_amount_placeholder: "Share (€)",
      split_credito: "CREDIT",
      split_debito: "DEBT"
    },
    confirm_delete_title: "Delete Transaction",
    confirm_delete_msg: "Are you sure you want to delete this transaction? This action is irreversible and balances will be recalculated.",
    quick_add_modal: {
      category_title: "New Category ({type})",
      merchant_title: "New Counterparty",
      payment_title: "New Payment Method",
      name_placeholder: "Name...",
      cancel: "Cancel",
      save: "Save"
    },
    new_account_modal: {
      title: "New Account",
      name_placeholder: "Name...",
      is_investment: "Investment Account",
      create: "Create",
      cancel: "Cancel"
    }
  },
  auth: {
    login: {
      title: "MS Ledger",
      subtitle: "Protect your wealth.",
      email_username: "Email or Username",
      email_placeholder: "Enter your email",
      password: "Password",
      forgot_password: "Forgot password?",
      totp_code: "Security Code (2FA)",
      totp_placeholder: "000000",
      totp_desc: "Open your Authenticator app to generate the code.",
      remember_me: "Remember me for 30 days",
      submit_2fa: "Verify and Log In",
      submit_password: "Log In with Password",
      back: "Back",
      or: "Or",
      face_id: "Log In with Passkey"
    },
    register: {
      subtitle: "Create a new account to get started.",
      username: "Username",
      username_placeholder: "e.g., mario99",
      email: "Email",
      email_placeholder: "mario@email.com",
      password: "Password",
      confirm_password: "Confirm Password",
      submit: "Register",
      have_account: "Already have an account?",
      login_link: "Log In"
    },
    forgot_password: {
      title: "Reset Password",
      desc: "Enter your email to receive the reset link.",
      email_placeholder: "Your email",
      submit: "Send Link",
      success: "Check your email! We have sent you the instructions."
    },
    reset_password: {
      title: "New Password",
      new_placeholder: "New Password",
      confirm_placeholder: "Confirm Password",
      submit: "Update Password"
    },
    errors: {
      email_required: "Enter your Email or Username above before using Face ID.",
      user_not_found: "User not found.",
      verification_failed: "Verification failed.",
      biometric_error: "Biometric error.",
      invalid_credentials: "Invalid email or password",
      email_not_verified: "Please verify your email before proceeding. Check your inbox for the verification link.",
      account_not_activated: "We are reviewing your request. Please try again later, you will be notified via email when your account is activated.",
      passwords_mismatch: "Passwords do not match.",
      password_length: "Password must be at least 6 characters long.",
      register_error: "Error during registration.",
      request_error: "Error during request.",
      connection_error: "Connection failed.",
      reset_error: "Error resetting password.",
      network_error: "Network error.",
      success_register: "Registration completed! Please check your inbox to verify your email address before logging in.",
      success_reset: "Password reset! You can now log in."
    }
  },
  balance: {
    title: "Closures and Balances",
    subtitle: "Reconcile app balances with your actual bank statement balances.",
    reconciliation_btn: "Start Reconciliation",
    calculating: "Calculating...",
    liquid_title: "Liquidity & Checking Accounts",
    investments_title: "Investments",
    empty_msg: "Select a date and click \"Start Reconciliation\" to begin.",
    toasts: {
      load_err: "Error loading balances.",
      diff_err: "Liquid accounts balance must match the expected balance exactly (Delta = 0).",
      success_close: "Account reconciled successfully!",
      close_err: "Error: {detail}"
    },
    table: {
      account: "Account",
      expected_balance: "App Expected Balance",
      actual_balance: "Bank Actual Balance",
      delta: "Delta",
      action: "Action",
      close_btn: "Close Account",
      closed_status: "Reconciled",
      never_closed: "Never closed",
      last_closure: "Last: {date} ({amount})",
      copy_expected: "Copy",
      copy_expected_mobile: "Copy Expected",
      expected_label_mobile: "Expected Balance",
      actual_label_mobile: "Actual Bank Balance",
      close_btn_mobile: "Close"
    }
  },
  calendar_page: {
    title: "Calendar",
    subtitle: "Daily cashflow view with future subscription forecasts.",
    today: "Today",
    loading_events: "Loading events...",
    toasts: {
      load_err: "Error loading data"
    },
    grid: {
      days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      days_short: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
    }
  },
  data_page: {
    title: "Anagraphics",
    subtitle: "Configure categories, accounts, counterparties, and cards.",
    search_placeholder: "Search item...",
    new_btn: "New",
    tabs: {
      categories: "Categories",
      accounts: "Bank Accounts",
      merchants: "Merchants",
      payment_methods: "Payment Methods",
      contacts: "Contacts"
    },
    table: {
      name: "Item Name",
      type: "Type",
      account_type: "Account Type",
      actions: "Actions",
      no_categories: "No categories found.",
      no_accounts: "No accounts found.",
      no_merchants: "No counterparties found.",
      no_payments: "No payment methods found.",
      no_contacts: "No contacts found.",
      subcat_tooltip: "Add Subcategory",
      investment_badge: "Investment",
      liquidity_badge: "Liquidity"
    },
    modal: {
      delete_title: "Delete Item",
      delete_message: "Are you sure you want to delete this item?",
      new_title: "Create New Item",
      edit_title: "Edit Item",
      name_label: "Name",
      transaction_type: "Transaction Type",
      type_expense: "Expense (Uscita)",
      type_income: "Income (Entrata)",
      type_transfer: "Transfer (Giroconto)",
      parent_label: "Subcategory of (Optional)",
      parent_none: "-- None (Main Category) --",
      is_investment: "Investment Account",
      is_investment_sub: "Excludes this account from cash liquidity calculations.",
      cancel: "Cancel",
      save: "Save",
      first_name: "First Name",
      last_name: "Last Name",
      email: "Email",
      phone_number: "Phone Number",
      vat_number: "VAT Number",
      tax_code: "Tax Code",
      address: "Address",
      website: "Website",
      matching_keywords: "Matching Keywords (comma-separated)",
      is_credit_card: "Credit Card",
      is_credit_card_sub: "Identify this account as a credit card.",
      is_shared: "Shared Account",
      is_shared_sub: "Joint/shared account.",
      is_obsolete: "Mark as Obsolete / Inactive",
      is_obsolete_sub: "Hide from main lists.",
      show_obsolete: "Show Obsolete",
      color: "Color",
      icon: "Icon",
      currency: "Currency"
    },
    toasts: {
      deleted: "Item deleted.",
      delete_err: "Could not delete: {detail}",
      created: "Item created!",
      updated: "Item updated!",
      save_err: "Error saving: {detail}",
      loading: "Loading master data..."
    }
  },
  debts_page: {
    title: "Debts & Credits",
    subtitle: "Manage loans to friends and your outstanding debts.",
    new_friend: "New Friend",
    new_debt: "New Debt",
    active_tab: "To Settle",
    settled_tab: "Settled",
    empty_msg: "No items in this section.",
    toasts: {
      load_err: "Error loading data",
      deleted: "Debt deleted!",
      delete_err: "Could not delete",
      contact_created: "Contact created",
      debt_created: "Debt registered",
      debt_updated: "Debt updated",
      save_err: "Error saving",
      status_updated: "Status updated!",
      status_err: "Error updating status",
      repay_linked: "Transaction linked!",
      repay_err: "Error",
      link_removed: "Link removed!"
    },
    modal: {
      delete_title: "Delete Debt",
      delete_message: "Are you sure you want to delete this debt? This will not change your actual bank balances, but will remove the reminder.",
      friend_title: "New Friend",
      friend_name: "Friend Name",
      friend_placeholder: "E.g., John Doe",
      cancel: "Cancel",
      save: "Save",
      debt_title: "Debt",
      debt_amount: "Total Amount",
      debt_desc: "Description (Optional)",
      debt_desc_placeholder: "E.g., Pizza dinner, loan...",
      repay_title: "Manage Reconciliation",
      repay_remaining: "Remaining to settle: {amount}",
      repay_status: "Status: {status}",
      repay_settled: "Settled",
      repay_active: "Active",
      repay_history: "Linked Transactions History",
      repay_amount_applied: "Amount applied",
      repay_no_links: "No linked transactions.",
      repay_link_new: "Link New Transaction",
      repay_select_tx: "Select a transaction...",
      repay_amount_to_apply: "Amount to Attribute to this Debt",
      repay_settle_checkbox: "Mark as settled (Close)",
      repay_submit: "Register Reconciliation",
      toggle_repay_status: "Mark as {status}",
      type_lent: "Lent (Credit)",
      type_borrowed: "Borrowed (Debt)",
      reopen_debt: "Reopen Debt",
      close_debt: "Close Debt",
      repay_total: "Reimbursement",
      remaining_label: "Remaining",
      tx_removed: "Transaction Removed",
      search_tx: "Search Transaction",
      settled_info: "This debt is currently settled. Use the 'Reopen Debt' button to add new transactions, or click the trash icon in history to remove an incorrect link."
    },
    aggregations: {
      credits_title: "Pending Credits",
      debts_title: "Pending Debts",
      net_balance: "Net Balance",
      net_credits: "You are up by {amount}",
      net_debts: "You owe {amount}",
      net_balanced: "Balances are even",
      by_friend: "Position by Friend",
      friend_credit: "Owes you {amount}",
      friend_debt: "You owe them {amount}",
      friend_settled: "Even"
    },
    card: {
      lent: "Lent to",
      borrowed: "Borrowed from",
      remaining: "Remaining: {amount} of {total}",
      settle_now: "Link / Settle",
      settled: "Settled",
      no_desc: "No description"
    }
  },
  documents_page: {
    inbox_title: "Telegram Inbox",
    empty_inbox: "Empty inbox. Send a file to the bot!",
    preview_title: "Document Preview",
    fullscreen_btn: "Open fullscreen",
    decrypting: "Decrypting file...",
    link_section_title: "Link to Transaction",
    search_placeholder: "Search by description or amount...",
    link_btn: "Link here",
    delete_btn: "Delete this file",
    delete_confirm: "Delete the file permanently?",
    empty_selection: "Select a document to begin",
    other_features_soon: "Other Functions (Coming Soon)",
    create_asset: "Create Asset",
    send_to_accountant: "Send to Accountant",
    archive_title: "Linked Archive",
    tab_inbox: "Inbox",
    tab_archive: "Archive",
    empty_archive: "No linked documents found.",
    linked_to: "Linked to transaction:",
    unlink_btn: "Dissociate Transaction",
    select_transaction_title: "Select Transaction",
    alias_label: "Alias / Custom Name",
    alias_placeholder: "Amazon invoice, bill...",
    save_alias_btn: "Rename",
    toasts: {
      preview_err: "Could not load document preview.",
      linked: "Document linked!",
      unlinked: "Document unlinked!",
      alias_updated: "Alias updated!"
    }
  },
  envelopes_page: {
    title: "Envelopes",
    subtitle: "Set aside money for future expenses and recurring targets.",
    new_btn: "New Envelope",
    liquid_title: "Available checking account liquidity",
    liquid_desc: "What you see on your banking app",
    allocated_title: "Allocated in Envelopes",
    allocated_desc: "Money already 'spent' mentally",
    unallocated_title: "Still Free (Unallocated)",
    unallocated_desc: "Your TRUE spendable wealth",
    my_goals: "Your Envelopes",
    empty_msg: "No envelopes set up. Create one to start budgeting!",
    toasts: {
      load_err: "Error loading data",
      deleted: "Envelope deleted!",
      delete_err: "Could not delete",
      saved: "Envelope saved!",
      save_err: "Error saving envelope"
    },
    card: {
      target: "Target: {target}",
      target_reached: "Completed!",
      delete_confirm: "Are you sure you want to delete this envelope?",
      no_desc: "No description",
      remaining_to_target: "Remaining: {amount}"
    },
    modal: {
      new_title: "New Envelope",
      edit_title: "Edit Envelope",
      delete_title: "Delete Envelope",
      name: "Envelope Name",
      name_placeholder: "E.g., Car Insurance, Taxes...",
      allocated: "Allocated Amount (€)",
      target: "Target Amount (Optional, €)",
      description: "Notes / Description",
      description_placeholder: "E.g., Due in November, monthly savings target...",
      cancel: "Cancel",
      save: "Save"
    }
  },
  goals_page: {
    title: "Financial Goals",
    subtitle: "Plan your long-term savings goals.",
    new_btn: "New Goal",
    allocated_title: "Allocated in Goals",
    empty_msg: "No goals set. Click 'New Goal' to start saving!",
    toasts: {
      load_err: "Error loading data",
      deleted: "Goal deleted!",
      delete_err: "Could not delete",
      saved: "Goal saved!",
      save_err: "Error saving goal",
      select_account: "Select an account!",
      alloc_success: "Funds allocated successfully!",
      alloc_err: "Allocation error: {detail}"
    },
    card: {
      target: "Target: {amount} by {date}",
      allocated: "Allocated: {amount} ({pct}%)",
      delete_confirm: "Are you sure you want to delete this goal?",
      target_date: "Target: {date}",
      add_funds: "Add Funds"
    },
    modal: {
      new_title: "New Goal",
      edit_title: "Edit Goal",
      delete_title: "Delete Goal",
      name: "Goal Name",
      name_placeholder: "E.g., Buy House, Japan Trip...",
      target: "Target Amount (€)",
      deadline: "Deadline Date",
      notes: "Notes / Description",
      notes_placeholder: "Details about the goal...",
      cancel: "Cancel",
      save: "Save",
      allocate_title_prefix: "Move Funds to",
      allocate_from_account: "WITHDRAW FROM WHICH ACCOUNT?",
      allocate_select_account: "Choose account...",
      allocate_desc: "The money will remain in your Net Worth, but will be hidden from free liquidity.",
      allocate_amount: "AMOUNT (€)",
      allocate_date: "DATE",
      allocate_submit: "Deposit",
      optional: "Optional"
    }
  },
  investments_page: {
    title: "Investments & Portfolio",
    subtitle: "Monitor assets, calculate PMC, and record buy/sell transactions.",
    import_btn: "Import CSV",
    new_asset_btn: "New Asset",
    new_order_btn: "Record Order",
    chart_title: "Portfolio Performance History",
    empty_chart: "No historical data for the chart.",
    positions_title: "Portfolio Positions",
    value: "Value",
    commission: "Commissions",
    order_type: "Order Type",
    date: "Date",
    shares: "Shares",
    price: "Price",
    orders_history: "Orders History",
    loading_msg: "Initializing terminal...",
    updating_data: "Updating data...",
    broker_selector_all: "All Brokers",
    ledger_empty: "The ledger is empty. Record your first transaction.",
    positions_empty: "No open positions in the portfolio.",
    assets_empty: "No assets registered.",
    tab_positions: "Active Positions",
    tab_ledger: "Order History (Ledger)",
    tab_assets: "Asset Directory",
    broker_liquidity: "Broker Liquidity",
    table: {
      asset: "Asset",
      shares: "Shares",
      pmc: "PMC",
      current_price: "Current Price",
      total_value: "Total Value",
      unrealized_pnl: "Unrealized P&L",
      date: "Date",
      event: "Event",
      price: "Price",
      value_eur: "Value (EUR)",
      actions: "Actions",
      ticker: "Ticker",
      name: "Name",
      type: "Type",
      currency: "Currency",
      last_price: "Last Price"
    },
    toasts: {
      load_err: "Error loading data.",
      asset_deleted: "Asset deleted!",
      asset_delete_err: "Could not delete asset.",
      order_deleted: "Order deleted!",
      order_delete_err: "Could not delete order.",
      asset_saved: "Asset saved successfully!",
      asset_save_err: "Error saving asset.",
      order_saved: "Order recorded successfully!",
      order_save_err: "Error saving order.",
      import_success: "Import completed successfully!",
      import_err: "Error importing."
    },
    modal: {
      asset_new_title: "New Asset",
      asset_edit_title: "Edit Asset",
      ticker: "Ticker / Identifier",
      ticker_placeholder: "E.g., SWDA.MI, AAPL, BTC...",
      name: "Asset Name",
      name_placeholder: "E.g., iShares MSCI World, Apple...",
      isin: "ISIN Code (Optional)",
      isin_placeholder: "E.g., IE00B4L5Y983...",
      asset_class: "Asset Class",
      asset_class_placeholder: "E.g., Equity, Crypto, Gold...",
      currency: "Quote Currency",
      currency_placeholder: "EUR, USD, etc.",
      current_price: "Current Market Price",
      search_ticker: "Search Ticker (Yahoo Finance)",
      ticker_not_found: "Ticker not found on Yahoo Finance.",
      ticker_verified: "Ticker Verified",
      symbol: "Symbol",
      instrument_name: "Instrument Name",
      original_currency: "Original Currency",
      save_asset_btn: "Save Asset in Directory",
      order_new_title: "Record New Order",
      order_edit_title: "Edit Order",
      select_asset: "Select Asset...",
      select_account: "Debit/Credit Account...",
      order_type_buy: "BUY",
      order_type_sell: "SELL",
      order_date: "Order Date",
      order_shares: "Quantity (Shares)",
      order_price: "Unit Price (€)",
      order_commission: "Commission (€, Optional)",
      broker_account: "Broker Account",
      event_type: "Event Type",
      buy_option: "BUY (Purchase)",
      sell_option: "SELL (Sale)",
      deposit_option: "DEPOSIT (Deposit Cash)",
      withdraw_option: "WITHDRAW (Withdraw Cash)",
      dividend_option: "DIVIDEND (Dividend)",
      interest_option: "INTEREST (Cash Interest)",
      fee_option: "FEE (Commission)",
      unit_price: "Unit Price",
      total_value_eur: "Total Value (€)",
      execution_date: "Execution Date",
      confirm_order_btn: "Confirm Order",
      registering: "Registering...",
      order_notes: "Notes / Transaction details",
      cancel: "Cancel",
      save: "Save",
      delete_confirm_asset: "Are you sure you want to delete this asset? All associated orders will also be deleted.",
      delete_confirm_order: "Are you sure you want to delete this order? The PMC and quantities will be recalculated.",
      delete_order_title: "Delete Order",
      delete_order_msg: "Are you sure you want to delete this order from the Ledger? The operation is irreversible and will immediately recalculate positions and charts."
    },
    import_page: {
      back_btn: "Back to Terminal",
      title: "Import Broker Data",
      subtitle: "Manage the bulk import flow of your investments.",
      system_aligned: "System Aligned",
      ready_data: "Ready for new data",
      step_staging: "Step 1: Staging",
      select_broker: "Select Broker",
      file_label_csv: "CSV File (Trade Republic)",
      upload_data_btn: "Upload New Data",
      step_processing: "Step 2: Processing",
      processing_desc: "Analyzes the staging area and creates the actual events in the Ledger: buys, sells, dividends, and fees will be calculated to the cent.",
      staging_status: "Staging Status",
      ready_to_process: "Ready to process",
      process_ledger_btn: "Process Ledger",
      step_sync: "Step 3: Synchronization",
      sync_desc: "Synchronize historical prices from Yahoo Finance. Only missing data will be downloaded to optimize performance.",
      asset_prices: "Asset Prices",
      diff_update: "Differential update",
      smart_backfill_btn: "Smart Backfill",
      footer_info: "Transaction ID detected via the broker's unique transaction_id.",
      safe_processing: "Secure Processing",
      dup_check: "Duplicate Check Active",
      loading_config: "Loading configuration...",
      toasts: {
        load_acc_err: "Could not load accounts.",
        select_file_acc: "Please select a file and a target account.",
        uploading_file: "Uploading file to staging area...",
        upload_err: "Error during upload",
        upload_conn_err: "Connection error during upload.",
        processing_ledger: "Processing transactions and updating Ledger...",
        process_err: "Error processing Ledger.",
        process_conn_err: "Connection error during processing.",
        syncing_prices: "Synchronizing historical prices from Yahoo Finance...",
        backfill_err: "Error during price backfill.",
        backfill_conn_err: "Connection error during backfill."
      }
    }
  },
  recurring_page: {
    title: "Subscriptions & Recurring Expenses",
    subtitle: "View and manage planned outflows and your recurring subscriptions.",
    new_btn: "New Subscription",
    active_tab: "Active",
    inactive_tab: "Deactivated",
    forecast_title: "Future Outflows Projections",
    forecast_loading: "Calculating projections...",
    forecast_30d: "Spending in next 30 days",
    forecast_90d: "Spending in next 90 days",
    forecast_365d: "Spending in next 365 days",
    empty_msg: "No subscriptions configured. Add your first subscription!",
    delete_title: "Delete Subscription",
    stats_7d: "Next 7 Days",
    stats_eom: "By End of Month",
    stats_30d: "Next 30 Days",
    stats_next_month: "Next Month",
    stats_12m: "Next 12 Months",
    stats_monthly_avg: "Monthly Average",
    toasts: {
      load_err: "Error loading data",
      deleted: "Subscription deleted!",
      delete_err: "Could not delete",
      saved: "Subscription saved!",
      save_err: "Error saving subscription"
    },
    card: {
      frequency_label: "Frequency:",
      next_date_label: "Next debit:",
      account_label: "Account:",
      status_label: "Status:",
      active: "Active",
      inactive: "Inactive",
      freq_daily: "Daily",
      freq_weekly: "Weekly",
      freq_monthly: "Monthly",
      freq_yearly: "Yearly",
      delete_confirm: "Are you sure you want to delete this recurring subscription?",
      suspend: "Pause",
      resume: "Resume"
    },
    modal: {
      new_title: "New Subscription",
      edit_title: "Edit Subscription",
      description: "Description / Name",
      description_placeholder: "E.g., Netflix, Spotify, Rent...",
      amount: "Amount (€)",
      category: "Category",
      account: "Debit Account",
      frequency: "Frequency",
      next_date: "Next Due Date",
      is_active: "Active Subscription (Triggers future dues)",
      cancel: "Cancel",
      save: "Save",
      none_placeholder: "None..."
    }
  },
  wishlist: {
    delete_btn: "Delete",
    title: "Wishlist (Cooling-Off Timer)",
    subtitle: "Register non-essential purchases to let them 'cool down' and prevent impulse buying.",
    add_btn: "Add Wish",
    new_wish: "New Wish",
    name: "Item Name",
    name_placeholder: "E.g., Smartwatch, New shoes...",
    amount: "Amount (€)",
    category: "Category",
    merchant: "Merchant / Brand",
    merchant_placeholder: "Select a merchant (optional)...",
    product_url: "Product Link",
    product_url_placeholder: "E.g., https://amazon.com/... (optional)",
    timer: "Cooling-Off Period",
    timer_24: "24 Hours",
    timer_48: "48 Hours (Recommended)",
    timer_72: "72 Hours",
    notes: "Additional Notes",
    notes_placeholder: "Why do I want to buy this? Do I really need it?",
    cancel: "Cancel",
    save: "Save Wish",
    total_saved: "Self-Control Savings",
    active_wishes: "Active Cooling-Off Period",
    archived_wishes: "Decision History",
    time_left: "Time left:",
    expired: "Time's Up!",
    want_it_question: "Do you still want to buy it?",
    yes_btn: "Yes, I still want it",
    no_btn: "No, I changed my mind",
    status_pending: "Cooling Off",
    status_saved: "Saved",
    status_bought: "Bought",
    empty_active: "No active cooling-off items. Outstanding self-control!",
    empty_archive: "No decisions recorded in history.",
    delete_confirm: "Are you sure you want to delete this wish?",
    toasts: {
      load_err: "Error loading wishlist items",
      saved: "Wish registered! The cooling-off timer has started.",
      save_err: "Could not save wish",
      deleted: "Wish removed",
      delete_err: "Could not delete",
      decision_saved: "Excellent self-control! {amount}€ has been moved to your Savings envelope.",
      decision_bought: "Wish confirmed. Go ahead and buy it!"
    }
  },
  admin_page: {
    title: "User Management",
    subtitle: "Manage registered users, enable/disable access, and control permissions.",
    table: {
      username: "Username",
      email: "Email",
      status: "Status",
      role: "Role",
      registered: "Registered At",
      email_verified: "Email Verified",
      two_factor: "2FA",
      last_access: "Last Access",
      last_pwd_change: "Password Change",
      actions: "Actions"
    },
    status_active: "Active",
    status_inactive: "Deactivated",
    status_2fa_active: "Active",
    status_2fa_inactive: "Inactive",
    never_changed: "Never modified (Reg.)",
    role_admin: "Administrator",
    role_admin_lvl: "Administrator (Lvl {level})",
    role_user: "User",
    btn_deactivate: "Deactivate",
    btn_activate: "Activate",
    btn_make_admin: "Make Admin",
    btn_make_admin_placeholder: "+ Elect as Admin",
    btn_remove_admin: "Remove Admin",
    access_denied: "Accesso Negato",
    access_denied_msg: "You do not have the required permissions to access this page.",
    filters: {
      search_placeholder: "Search by username, email or name...",
      role_all: "All roles",
      status_all: "All statuses",
      "2fa_all": "All 2FA"
    },
    toasts: {
      load_err: "Error loading users",
      update_success: "User updated successfully!",
      update_err: "Could not update user",
      self_demotion_err: "You cannot remove your own administrator privileges."
    }
  },
  admin_market_page: {
    title: "Market Data Monitor",
    subtitle: "Check asset quotes (Stocks, Crypto, ETFs) and Forex rates updated via Yahoo Finance.",
    btn_refresh: "Force Update",
    btn_refreshing: "Updating...",
    tab_tickers: "Active Tickers",
    tab_forex: "Exchange Rates",
    search_ticker_placeholder: "Search ticker or name...",
    table: {
      ticker: "Ticker",
      name: "Name",
      type: "Type",
      currency: "Orig. Currency",
      price: "Last Price",
      user_count: "User Positions",
      last_updated: "Last Updated"
    },
    forex_card: {
      from_eur: "Exchange rate in EUR",
      inverse: "Inverse (1 EUR = {val} {curr})"
    },
    toasts: {
      load_err: "Error loading market data",
      refresh_success: "Market prices and Forex rates successfully updated!",
      refresh_err: "Could not update market data"
    }
  },
  support_page: {
    title: "Customer Support",
    subtitle: "Submit a support request or check the status of your open tickets.",
    btn_new_ticket: "+ New Ticket",
    btn_submitting: "Submitting...",
    btn_reply: "Send Reply",
    btn_replying: "Sending...",
    form: {
      title: "Open a New Ticket",
      subject: "Subject",
      subject_placeholder: "What is the issue or request?",
      description: "Detailed Description",
      description_placeholder: "Provide as much information as possible...",
      priority: "Priority",
      btn_submit: "Submit Ticket",
      btn_cancel: "Cancel"
    },
    table: {
      id: "ID",
      subject: "Subject",
      status: "Status",
      priority: "Priority",
      created_at: "Created At",
      last_update: "Last Update",
      assigned_to: "Assigned To"
    },
    details: {
      title: "Ticket Details",
      btn_back: "Back to list",
      info_title: "Ticket Information",
      chat_placeholder: "Type a reply to support...",
      system_user: "System",
      support_agent: "Agent"
    },
    status: {
      open: "Open",
      in_progress: "In Progress",
      resolved: "Resolved",
      closed: "Closed"
    },
    priority: {
      low: "Low",
      medium: "Medium",
      high: "High",
      critical: "Critical"
    },
    toasts: {
      load_err: "Unable to load tickets.",
      create_success: "Ticket created successfully!",
      create_err: "Error creating ticket.",
      reply_success: "Reply sent successfully!",
      reply_err: "Unable to send reply."
    }
  },
  admin_tickets_page: {
    title: "Manage Support Tickets",
    subtitle: "Resolve user tickets, assign them to admins, and update priorities and statuses.",
    table: {
      user: "User",
      assigned_to: "Assigned To",
      no_assignee: "Unassigned",
      select_assignee: "Assign to...",
      btn_assign_me: "Assign to me"
    },
    filters: {
      status_all: "All statuses",
      priority_all: "All priorities",
      assigned_all: "All tickets",
      assigned_me: "Assigned to me",
      assigned_unassigned: "Unassigned"
    },
    toasts: {
      update_success: "Ticket updated successfully!",
      update_err: "Could not update ticket."
    }
  },
  admin_analytics_page: {
    title: "Application Analytics",
    subtitle: "Monitor overall user activity, transaction volumes, file storage footprints, and security measures adoption.",
    cards: {
      total_users: "Registered Users",
      active_users: "Active Users",
      active_desc: "7 days / 30 days",
      total_transactions: "Total Transactions",
      storage_size: "Document Storage",
      total_tickets: "Support Tickets",
      security_info: "User Security",
      total_ai_requests: "Google AI Requests"
    },
    sections: {
      activity_trends: "Activity Trends (Last 7 Days)",
      tx_distribution: "Transaction Distribution by Type",
      security_adoption: "Security Measures Adoption",
      top_tx_users: "Top Users (Most Transactions)",
      top_storage_users: "Top Storage Users (Highest File Storage)",
      attachments_mime: "File Breakdown by MIME Type",
      ticket_status: "Support Ticket Status Overview",
      top_ai_users: "AI Usage per User"
    },
    labels: {
      active_2fa: "2FA Enabled",
      inactive_2fa: "2FA Disabled",
      passkeys: "Registered Passkeys",
      open: "Open",
      in_progress: "In Progress",
      resolved: "Resolved",
      closed: "Closed",
      tx_count: "{val} transactions",
      storage_mb: "{val} MB",
      mime_type: "MIME Type",
      count: "Count",
      no_data: "No data available.",
      ai_count: "{val} requests"
    },
    toasts: {
      load_err: "Unable to load application usage analytics."
    }
  },
  admin_settings_page: {
    title: "System Settings",
    subtitle: "Configure system-wide parameters and manage features access control switches.",
    table: {
      key: "Setting",
      description: "Description",
      value: "Value",
      admin_level: "Min. Modify Level",
      actions: "Actions",
      btn_save: "Save",
      placeholder: "Value..."
    },
    toasts: {
      load_err: "Unable to load system settings.",
      update_success: "Setting successfully updated!",
      update_err: "Could not update setting."
    }
  }
};
